import { IMessage } from "domain/IMessage";
import API from "utils/API";
import authHeader from "utils/auth-header";
import { IAddMessageResponse } from "../domain/IAddMessageResponse";
import { IChatMessage } from "../domain/IChatMessage";
import { IGetChatMessagesResponse } from "../domain/IGetChatMessagesResponse";
import { getQeuryParams } from "utils/queryParamsUtil";
import { IGetScrollDataRequestParams } from "../domain/IGetScrollDataRequestParams";

const getAllEmployeeMessages = async (
  params: IGetScrollDataRequestParams,
  signal: AbortSignal
): Promise<IChatMessage[]> => {
  var headers = authHeader();
  try {
    const response = await API.get<IGetChatMessagesResponse>(
      `/chat/protected/chat${getQeuryParams(params)}`,
      { headers, signal }
    );
    let messages = response.data.messages;
    return messages;
  } catch (err) {
    throw err;
  }
};

const sendMessage = async (data: any): Promise<IAddMessageResponse> => {
  var headers = authHeader();
  try {
    const response = await API.post<IAddMessageResponse>(
      "/chat/protected/chat",
      data,
      { headers }
    );
    let message = response.data;
    console.log(message);
    return message;
  } catch (err) {
    throw err;
  }
};

const deleteMessage = async (messageId: number): Promise<IMessage> => {
  var headers = authHeader();
  try {
    const response = await API.delete<IMessage>(
      `/chat/protected/chat/${messageId}`,
      { headers }
    );
    let message = response.data;
    return message;
  } catch (err) {
    throw err;
  }
};

const updateVisibility = async (data: any): Promise<IAddMessageResponse> => {
  var headers = authHeader();
  try {
    const response = await API.put<IAddMessageResponse>(
      "/chat/protected/chat/visibility",
      data,
      { headers }
    );
    let item = response.data;
    return item;
  } catch (err) {
    throw err;
  }
};

export const chatService = {
  getAllEmployeeMessages,
  sendMessage,
  deleteMessage,
  updateVisibility,
};
